
export default function Contact() {
  return (
    <section id="contact" className="py-16 bg-[#266fb7]">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            お問い合わせ
          </h2>
          <p className="text-lg text-blue-100 max-w-2xl mx-auto">
            ご質問やご相談がございましたら、お気軽にお問い合わせください。
            専門スタッフが丁寧にサポートいたします。
          </p>
        </div>

        {/* 電話番号紹介セクション */}
        <div className="mt-16 bg-white rounded-2xl shadow-lg p-8 max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* 左側：電話番号・営業時間 */}
            <div className="text-center lg:text-left">
              <div className="bg-gradient-to-r from-[#01a7ea] to-[#2d88ba] rounded-xl p-8 text-white mb-8">
                <div className="flex items-center justify-center lg:justify-start mb-4">
                  <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-phone-fill text-2xl"></i>
                  </div>
                  <h4 className="text-xl font-bold">お電話はこちら</h4>
                </div>
                <p className="text-4xl font-bold mb-2">090-4434-4518</p>
                <p className="text-lg opacity-90">お気軽にお電話ください</p>
              </div>
              
              <div className="flex items-start space-x-3">
                <i className="ri-time-line text-[#01a7ea] text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-800 mb-1">営業時間</h4>
                  <p className="text-gray-600">平日：9:00〜18:00</p>
                </div>
              </div>
              
              <div className="mt-6 p-4 bg-blue-50 rounded-lg border-l-4 border-[#01a7ea]">
                <p className="text-sm text-gray-700">
                  <i className="ri-information-line text-[#01a7ea] mr-2"></i>
                  お電話の際は「ホームページを見た」とお伝えください
                </p>
              </div>
            </div>

            {/* 右側：お問い合わせフォーム */}
            <div>
              <h4 className="text-xl font-bold text-gray-900 mb-6">メールでのお問い合わせ</h4>
              
              <div className="bg-gray-50 rounded-lg p-6">
                <form className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      会社名
                    </label>
                    <input
                      type="text"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#01a7ea] focus:border-transparent text-sm"
                      placeholder="株式会社○○○"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      お名前
                    </label>
                    <input
                      type="text"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#01a7ea] focus:border-transparent text-sm"
                      placeholder="山田太郎"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      メールアドレス
                    </label>
                    <input
                      type="email"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#01a7ea] focus:border-transparent text-sm"
                      placeholder="example@company.co.jp"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      お問い合わせ内容
                    </label>
                    <textarea
                      rows={4}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#01a7ea] focus:border-transparent text-sm resize-none"
                      placeholder="お問い合わせ内容をご記入ください"
                      maxLength={500}
                    ></textarea>
                    <p className="text-xs text-gray-500 mt-1">500文字以内</p>
                  </div>
                  
                  <button
                    type="submit"
                    className="w-full bg-[#01a7ea] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#2d88ba] transition-colors cursor-pointer whitespace-nowrap"
                  >
                    メールで問い合わせる
                  </button>
                </form>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
